import React from 'react'
import { Button } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Wrapper, IconWrapper, Title } from './styled'

interface IProps {
  title: string
  icon: IconProp
  action?: () => void
  actionIcon?: IconProp
  actionTitle?: string
}

const EmptyState = ({
  title,
  icon,
  action,
  actionIcon,
  actionTitle
}: IProps) => {
  return (
    <Wrapper>
      <IconWrapper>
        <FontAwesomeIcon icon={icon} />
      </IconWrapper>
      <Title>{title}</Title>
      {actionIcon && (
        <Button onClick={action}>
          <FontAwesomeIcon icon={actionIcon} />
          {actionTitle}
        </Button>
      )}
    </Wrapper>
  )
}

export default EmptyState
